import { Card, Col, Row } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const InvoicePreload = () => (
  <div className="container-fluid py-3" aria-busy="true" aria-label="در حال بارگذاری">
    <div className="d-flex justify-content-center gap-3 mb-3">
      <TextLoading width={110} height={32} isWidthPx />
      <TextLoading width={80} height={32} isWidthPx />
    </div>
    <Card>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <TextLoading width={120} height={45} isWidthPx />
          <TextLoading width={180} height={20} isWidthPx />
          <div>
            <TextLoading width={110} height={12} isWidthPx />
            <div className="mt-2">
              <TextLoading width={95} height={10} isWidthPx />
            </div>
          </div>
        </div>

        {[1, 2].map(section => (
          <section className="mb-4" key={section}>
            <TextLoading width="24%" height={18} />
            <div className="border rounded p-3 mt-2">
              <Row className="g-3">
                {[1, 2, 3, 4, 5, 6].map(item => (
                  <Col xs={12} md={4} key={item}>
                    <TextLoading width={`${55 + (item % 3) * 12}%`} height={11} />
                  </Col>
                ))}
              </Row>
            </div>
          </section>
        ))}

        <TextLoading width="100%" height={34} />
        <div className="mt-3 d-flex justify-content-end">
          <TextLoading width={180} height={16} isWidthPx />
        </div>
      </Card.Body>
    </Card>
  </div>
);

export default InvoicePreload;
